import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/audio/text-click.ogg'
import _imports_1 from '@/assets/audio/text-click.mp3'


const _hoisted_1 = {
  ref: "textClickAudio",
  preload: "auto"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("source", {
  src: _imports_0,
  type: "audio/ogg"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("source", {
  src: _imports_1,
  type: "audio/mpeg"
}, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("audio", _hoisted_1, _hoisted_4, 512),
    _createElementVNode("button", {
      class: "menu-button",
      type: "button",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.play && _ctx.play(...args)))
    }, _toDisplayString(_ctx.text), 1)
  ], 64))
}